import React from 'react';

const Services = () => {
  return (
    <section id="services" className="py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-light text-center tracking-wide mb-4">OUR SERVICES</h2>
        <div className="section-divider"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
          <div className="flex flex-col justify-center" data-aos="fade-right">
            <div className="mb-8">
              <h3 className="text-xl font-light mb-4 tracking-wide">MENTAL HEALTH THERAPY</h3>
              <p className="text-gray-700 leading-relaxed">
                Support group therapy, child therapy, parent therapy, and mother & child therapy. 
                Theatre therapy, Yoga and spiritual support.
              </p>
            </div>
            
            <div className="mb-8">
              <h3 className="text-xl font-light mb-4 tracking-wide">SKILLS DEVELOPMENT</h3>
              <p className="text-gray-700 leading-relaxed">
                Through art development: theatre plays, primary painting skills e.g. lining, design, printing, 
                agricultural skills e.g. how to make your own food, cooking classes crochet.
              </p>
            </div>
            
            <div>
              <h3 className="text-xl font-light mb-4 tracking-wide">GOODS</h3>
              <p className="text-gray-700 leading-relaxed">
                Monthly toiletries, clothes, and lunchtime.
              </p>
            </div>
          </div>
          <div data-aos="fade-left">
            <div className="grid grid-cols-2 gap-4">
              <img 
                src="/images/image00004.jpeg" 
                alt="Mental health therapy service" 
                className="w-full object-contain h-48"
              />
              <img 
                src="/images/image00005.jpeg" 
                alt="Skills development service" 
                className="w-full object-contain h-48"
              />
              <img 
                src="/images/image00006.jpeg" 
                alt="Community support service" 
                className="w-full object-contain h-48"
              />
              <img 
                src="/images/image00003.jpeg" 
                alt="Goods and necessities service" 
                className="w-full object-contain h-48"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;